import toastr from 'toastr';
import flattenDepth from 'lodash/flattenDepth';
import isPlainObject from 'lodash/isPlainObject';
import isString from 'lodash/isString';
import castArray from 'lodash/castArray';
import compact from 'lodash/compact';

toastr.options.closeButton = true;
toastr.options.timeOut = 10000;
toastr.options.extendedTimeOut = 10000;
toastr.options.progressBar = true;
toastr.options.tapToDismiss = false;

const toConsumableArray = (messages, type = 'info') => {
	const result = compact(castArray(messages)).map((message) => {
		if (isString(message)) {
			return {type, message};
		} else if (isPlainObject(message)) {
			return message;
		}
		return null;
	});
	return compact(result);
};

const show = (...messages) => {
	const flat = flattenDepth(messages, 2);
	flat.forEach((obj) => {
		toastr[obj.type](obj.message, obj.title || null, obj.options);
	});
};

export default {
	show, toConsumableArray
};
